import { Directive } from '@angular/core';
import {
  AbstractControl,
  UntypedFormGroup,
  NG_VALIDATORS,
  ValidationErrors,
  Validator,
  ValidatorFn,
} from '@angular/forms';

function validatePassword(): ValidatorFn {
  return (control: AbstractControl) => {
    let isValid = false;
    if (control && control instanceof UntypedFormGroup) {
      const group = control as UntypedFormGroup;
      if (group.controls['password'] && group.controls['passwordConfirm']) {
        isValid =
          group.controls['password'].value ===
          group.controls['passwordConfirm'].value;
      }
    }
    if (isValid) {
      return null;
    } else {
      return { passwordCheck: 'failed' };
    }
  };
}

@Directive({
    selector: '[appCheckPassword]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: CheckPasswordDirective,
            multi: true,
        },
    ],
    standalone: false
})
export class CheckPasswordDirective implements Validator {
  private valFn;

  constructor() {
    this.valFn = validatePassword();
  }

  validate(c: AbstractControl): ValidationErrors | null {
    return this.valFn(c);
  }
}
